import {AbstractAcStandardMapper} from "../abstract-ac-standard.mapper";

export class FrAcFonSynthesisMapper extends AbstractAcStandardMapper {
}
